export default {
    baseStyle: {
        heading: {
            letterSpacing: '1.2px'
        },
        // Rare fallback when Size row isn't in CMS HTML
        sizeGuideFallback: {
            display: 'inline-flex',
            alignItems: 'center',
            flexShrink: 0,
            gap: '5px',
            marginLeft: 'auto',
            padding: 0,
            fontSize: '14px',
            lineHeight: '22px',
            letterSpacing: '0.07px',
            textDecoration: 'underline',
            textUnderlineOffset: '4px',
            color: 'black.100',
            whiteSpace: 'nowrap',
            fontWeight: '300',
            fontFamily: 'body'
        },
        content: {
            fontSize: '14px',
            lineHeight: '22px',
            letterSpacing: '0.07px',
            sx: {
                h3: {
                    fontSize: '14px',
                    lineHeight: '22px',
                    letterSpacing: '0.07px',
                    display: 'inline-block',
                    fontWeight: '400',
                    marginRight: '15px'
                },
                'h3 + p': {
                    fontSize: '14px',
                    lineHeight: '22px',
                    letterSpacing: '0.07px',
                    display: 'inline'
                },
                'br + h3, p + h3': {
                    marginTop: '10px'
                },
                // Collapsed Details: keep H3 attribute rows; hide disclaimer paragraphs.
                '&.details-collapsed > p': {
                    display: 'none'
                },
                '&.details-collapsed > h3 + p': {
                    display: 'inline'
                },
                // CMS often emits empty <p> + <br> after Size before the disclaimer.
                '&.details-collapsed > h3 + p:empty': {
                    display: 'none'
                },
                '&.details-collapsed > br:not(:has(+ h3))': {
                    display: 'none'
                },
                '&.details-collapsed > .details-size-row ~ *': {
                    display: 'none'
                },
                // Collapsed: one line between Size label and Size Guide, with "..."
                '&.details-collapsed .details-size-row': {
                    alignItems: 'center'
                },
                '&.details-collapsed .details-size-copy': {
                    display: 'block',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                },
                '&.details-collapsed .details-size-copy h3': {
                    display: 'inline'
                },
                '&.details-collapsed .details-size-copy h3 + p': {
                    display: 'inline'
                },
                '.details-size-row': {
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'space-between',
                    gap: '10px',
                    width: '100%',
                    maxWidth: '100%',
                    minWidth: 0,
                    boxSizing: 'border-box'
                },
                '.details-size-copy': {
                    display: 'flex',
                    alignItems: 'flex-start',
                    flex: 1,
                    minWidth: 0
                },
                '.details-size-copy h3': {
                    flexShrink: 0,
                    marginTop: 0
                },
                '.details-size-copy h3 + p': {
                    display: 'block',
                    flex: 1,
                    minWidth: 0
                },
                'br + .details-size-row, p + .details-size-row': {
                    marginTop: '10px'
                },
                '.size-guide-inline': {
                    display: 'inline-flex',
                    alignItems: 'center',
                    alignSelf: 'flex-start',
                    flexShrink: 0,
                    gap: '5px',
                    padding: 0,
                    border: 0,
                    background: 'transparent',
                    cursor: 'pointer',
                    fontSize: '14px',
                    lineHeight: '22px',
                    letterSpacing: '0.07px',
                    fontWeight: '300',
                    fontFamily: 'body',
                    color: 'black.100',
                    textDecoration: 'underline',
                    textUnderlineOffset: '2px',
                    whiteSpace: 'nowrap'
                },
                '.size-guide-inline img': {
                    display: 'block',
                    width: '16px',
                    height: '10px',
                    flexShrink: 0
                },
                a: {
                    textDecoration: 'underline',
                    _hover: {
                        color: 'blue.700'
                    }
                }
            }
        }
    }
}
